import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { servicesData } from "../../constants";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function SwipeableTextMobileStepper() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = servicesData.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ flexGrow: 1, position: "relative" }}>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {servicesData.map((step, index) => (
          <div key={step.service}>
            {Math.abs(activeStep - index) <= 2 ? (
              <img
                height={500}
                width={450}
                // layout="responsive"
                style={{
                  height: "90vh",
                  // position: "absolute",
                  display: "block",
                  maxWidth: "100%",
                  overflow: "hidden",
                  opacity: "0.5",
                  width: "100vw",
                  zIndex: -99,
                }}
                src={step.illustration}
                alt={step.service}
              />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      {/* <Gene20Box
        sx={{
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          width: "100%",
          height: "100%",
          zIndex: 1,
        }}
      >
        <Typography
          variant="h3"
          align="center"
          sx={{
            color: "white",
            display: "flex",
            alignItems: "center",
            height: 50,
            pl: 2,
            fontVariant: "all-small-caps",
          }}
        >
          {servicesData[activeStep].service}
        </Typography>
      </Gene20Box> */}
      <MobileStepper
        sx={{ background: "transparent" }}
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="large"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            <NavigateNext />
          </Button>
        }
        backButton={
          <Button size="large" onClick={handleBack} disabled={activeStep === 0}>
            <NavigateBefore />
          </Button>
        }
      />
    </Box>
  );
}

export default SwipeableTextMobileStepper;
